import { render, staticRenderFns } from "./kefuConfig.vue?vue&type=template&id=1264eb13&scoped=true"
import script from "./kefuConfig.vue?vue&type=script&lang=js"
export * from "./kefuConfig.vue?vue&type=script&lang=js"
import style0 from "./kefuConfig.vue?vue&type=style&index=0&id=1264eb13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1264eb13",
  null
  
)

export default component.exports